import { IUser } from '@alberta/konexi-shared';
import { Inject, Injectable, NgZone } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { UsersChannel } from 'src/app/business/user/contracts/user.channel';
import { IAppController } from 'src/app/common/contracts/controller/app-controller';
import { IDispatcher } from 'src/app/common/contracts/dispatch/dispatcher';
import { IPlatformSync, PlatformSyncToken } from 'src/app/common/contracts/sync/platform-sync';
import { ISyncState } from 'src/app/common/contracts/sync/sync-state';
import { AppController } from 'src/app/common/controller/app-controller';
import { Dispatcher } from 'src/app/common/dispatch/dispatcher';
import { EnvironmentService } from 'src/app/shared/services/environment/environment.service';

import { UsersModelName } from '../../models/model-names';
import { SyncProgressEvent } from '../../models/sync-progress-event';
import { AccountService } from '../account.service';
import { EventService } from '../event.service';
import { RegionService } from '../region.service';
import { SyncService } from './sync.service';

@Injectable()
export class UsersSyncService extends SyncService<IUser> {
  constructor(
    private _storage: Storage,
    private _regionService: RegionService,
    private _accountService: AccountService,
    private _environmentService: EnvironmentService,
    @Inject(AppController) appController: IAppController,
    @Inject(Dispatcher) dispatcher: IDispatcher<IUser>,
    eventService: EventService<SyncProgressEvent>,
    ngZone: NgZone,
    @Inject(PlatformSyncToken) platformSync: IPlatformSync
  ) {
    super(UsersModelName, appController, dispatcher, eventService, ngZone, platformSync);
  }

  public canSync(channel: string): boolean {
    return channel === UsersChannel.CREATE || channel === UsersChannel.EDIT || channel === UsersChannel.DELETE;
  }

  protected async afterSync(syncState: ISyncState<IUser>) {
    const userId = await this._accountService.getCurrentUserId();
    const myUser = syncState.updated.find(user => user._id === userId);

    if (!myUser || !myUser.groups || !myUser.groups.length) {
      return;
    }

    const allUserRegions = await this._regionService.getRegions(myUser.groups);
    if (allUserRegions && allUserRegions.length) {
      await this._accountService.resetCurrentUser(myUser, allUserRegions);
    }
  }

  protected async onPatched(user: IUser): Promise<void> {
    await super.onPatched(user);
    await this.afterSync({ deleted: [], created: [], updated: [user] });
  }
}
